import { useApi } from '@/composables/api.ts'
import type { NodeInfo } from '@deepcloud/api-deep-box'

export const useDeepBoxNodesInfoStore = defineStore('deepBoxNodesInfo', () => {
  const { deepBoxAPI } = useApi()

  const fetchNodeInfoPending = ref(false)
  const nodeInfo = ref<NodeInfo>()

  async function fetchNodeInfo(nodeId: string) {
    fetchNodeInfoPending.value = true
    try {
      const res = await deepBoxAPI.value.nodesInfo.get(nodeId)
      if (res.data) {
        nodeInfo.value = { ...res.data }
      }
      return Promise.resolve(res)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      fetchNodeInfoPending.value = false
    }
  }

  return {
    // state
    fetchNodeInfoPending,
    nodeInfo,
    // actions
    fetchNodeInfo,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useDeepBoxNodesInfoStore, import.meta.hot),
  )
}
